

export const FONT = "'Bell MT', serif";

export const C = {
  ink: "#000000",
  text: "#333333",
  secondary: "#666666",
  line: "#EEEEEE",
  lineStrong: "#E0E0E0",
  soft: "#F9F9F9",
  paper: "#FFFFFF",
  success: "#2E7D32",
  successBg: "#F1F8E9",
  danger: "#D32F2F",
  dangerBg: "#FFF5F5",
};

/** Applies the site font to every MUI text component inside the Account pages. */
export const accountRootSx = {
  fontFamily: FONT,
  color: C.text,
  "& .MuiTypography-root, & .MuiButton-root, & .MuiInputBase-root, & .MuiInputLabel-root, & .MuiFormHelperText-root, & .MuiTab-root, & .MuiChip-root, & .MuiPaginationItem-root, & .MuiBreadcrumbs-root":
    { fontFamily: FONT },
};

/* ------------------------------------------------------------------ */
/* Text styles                                                          */
/* ------------------------------------------------------------------ */

/** Small uppercase label — same treatment as the old Profile section labels. */
export const labelSx = {
  fontFamily: FONT,
  fontSize: "0.75rem",
  fontWeight: 700,
  letterSpacing: "2px",
  textTransform: "uppercase",
  color: C.ink,
};

/** Muted uppercase label for field names and metadata. */
export const eyebrowSx = {
  fontFamily: FONT,
  fontSize: "0.7rem",
  fontWeight: 700,
  letterSpacing: "1.5px",
  textTransform: "uppercase",
  color: C.secondary,
};

export const clamp = (lines) => ({
  display: "-webkit-box",
  WebkitLineClamp: lines,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  wordBreak: "break-word",
});

/* ------------------------------------------------------------------ */
/* Buttons and inputs                                                   */
/* ------------------------------------------------------------------ */

export const primaryButtonSx = {
  bgcolor: C.ink,
  color: "#fff",
  borderRadius: 0,
  boxShadow: "none",
  fontFamily: FONT,
  fontWeight: 700,
  fontSize: "0.8rem",
  letterSpacing: "2px",
  textTransform: "uppercase",
  minHeight: 48,
  px: 4,
  "&:hover": { bgcolor: "#333", boxShadow: "none" },
  "&.Mui-disabled": { bgcolor: C.lineStrong, color: C.secondary },
};

export const outlineButtonSx = {
  color: C.ink,
  border: `1px solid ${C.ink}`,
  borderRadius: 0,
  fontFamily: FONT,
  fontWeight: 700,
  fontSize: "0.75rem",
  letterSpacing: "2px",
  textTransform: "uppercase",
  minHeight: 44,
  px: 3,
  "&:hover": { bgcolor: C.ink, color: "#fff", borderColor: C.ink },
  "&.Mui-disabled": { borderColor: C.lineStrong, color: "#9E9E9E" },
};

/** Text button (e.g. "Back to invoices"). */
export const textButtonSx = {
  color: C.ink,
  borderRadius: 0,
  fontFamily: FONT,
  fontWeight: 700,
  fontSize: "0.75rem",
  letterSpacing: "2px",
  textTransform: "uppercase",
  minHeight: 44,
  px: 1,
  "&:hover": { bgcolor: "transparent", textDecoration: "underline", textUnderlineOffset: "4px" },
};

/** Outlined text field — same as the old Profile inputs, with a readable label colour. */
export const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 0,
    fontSize: "0.95rem",
    backgroundColor: "#fff",
    fontFamily: FONT,
    "& fieldset": { borderColor: C.lineStrong },
    "&:hover fieldset": { borderColor: C.ink },
    "&.Mui-focused fieldset": { borderColor: C.ink, borderWidth: "1px" },
  },
  "& .MuiInputLabel-root": {
    fontSize: "0.8rem",
    letterSpacing: "1px",
    textTransform: "uppercase",
    color: C.secondary,
    fontFamily: FONT,
    "&.Mui-focused": { color: C.ink },
  },
  "& .MuiFormHelperText-root": { fontFamily: FONT, mx: 0 },
};

export const paginationSx = {
  "& .MuiPaginationItem-root": {
    borderRadius: 0,
    fontFamily: FONT,
    minWidth: 40,
    height: 40,
    "&.Mui-selected": { bgcolor: C.ink, color: "#fff", "&:hover": { bgcolor: "#333" } },
  },
  // On phones the first/last buttons are hidden so the pager stays on one line.
  "& .MuiPaginationItem-firstLast": { display: { xs: "none", sm: "inline-flex" } },
};

/** Standard page container width and side padding (MUI Container "lg", as on Profile). */
export const CONTAINER = "lg";

